import { render, staticRenderFns } from "./GraficoBarraDRE.vue?vue&type=template&id=0154c7bb"
import script from "./GraficoBarraDRE.vue?vue&type=script&lang=js"
export * from "./GraficoBarraDRE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports